
import React, { useState, useEffect } from 'react';
import { useAPIQuery } from './useAPIQuery';
import DefaultLoading from './DefaultLoading';
import DefaultError from './DefaultError';

import APIError461 from './APIError461';
import APIErrorGeneric from './APIErrorGeneric';

import { useSnapshot } from 'valtio';
import { editorState } from '../../editor/editor-state';
import { sessionState } from '@/app/sessionState';
import config from '@/app/config';


/**
 * DataFetcher Component
 *
 * @param {object} props
 * @param {string} props.url - The API endpoint to fetch data from or APIRequest object.
 * @param {Array|string} [props.queryKey] - Unique key for the query. If not provided, endpoint is used.
 * @param {React.ReactNode} [props.loadingFallback] - (Optional) Custom loading component.
 * @param {React.ReactNode} [props.errorFallback] - (Optional) Custom error component.
 * @param {function} props.children - Render prop function receiving the data.
 * @param {object} props.options - Optional React Query options.
 */
export function DataFetcher({
  url,
  loadingFallback,
  errorFallback,
  children,
  options,
}) {
  var sampleData = null;
  const { demoData } = useSnapshot(sessionState);

  let isSampleData = false;
  let cardUrl = `${config.API_URL}/api/gateway/card/${sessionState.cardId}?channel=artifacts&includeCardDefinition=true`;
  if (typeof url === 'object' && url.url) {
    if (isSampleData && sessionState.cardId) url.url = cardUrl;
  } else {
    if (typeof url === 'string') {
      isSampleData = url.indexOf("adenin-catalog.netlify.app") > -1;
      if (isSampleData && sessionState.cardId) {
        url = cardUrl;
      }
    }
  }

  if (typeof url === 'object' && url.parameters && url.sampleData) {
    if(url.parameters.url != undefined && !url.parameters.url) url.url = url.sampleData;  // switch to sampleData when url parameter is empty
  }

  // console.log("DataFetcher", url, isSampleData, sessionState.cardId, demoData);

  const { data, isLoading, isError, error, refetch } = useAPIQuery(url, options) ;

  if (isLoading) {
    return loadingFallback || <DefaultLoading />;
  }

  if (isError) {
    return errorFallback
      ? React.cloneElement(errorFallback, { error, refetch })
      : <DefaultError error={error} refetch={refetch} />;
  }

  var _data = data;

  var _sampleData = demoData.data;

  if (_sampleData && _sampleData != '{}' && demoData.enabled && (url === url.sampleData || !url.sampleData)) {

    try {
      sampleData = JSON.parse(_sampleData);
      if (Array.isArray(sampleData)) sampleData = { items: sampleData };
      _data = sampleData;
    } catch (e) {
      console.error(e);
      sampleData = null;
    }
  }

  if (_data?.ErrorCode) {
    if (_data.ErrorCode === 461) return <APIError461 data={_data} />

    return <APIErrorGeneric data={_data} />
  }

  if (!_data) return null;
  if (!children) return null;

  var _context = {};
  //console.log("DataFetcher", url, _data, _context);

  // Support both function children and element children
  return typeof children === "function"
    ? children(_data, _context)
    : cloneElement(children, { data: _data, context: _context });
}